import { render } from "./button.vue?vue&type=template&id=6fcc8a9f"
const script = {}

import exportComponent from "D:\\Coding\\Project\\Moisture-Sensor-Project-\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__